export const replacePrepositionsWhitespaces = (str?: string | null) => {
  if (!str) return str

  // TODO: improve this
  // inserts white space
  return str
    .replaceAll(' на ', ' на ')
    .replaceAll(' На ', ' На ')
    .replaceAll(' прямо ', ' прямо ')
    .replaceAll(' Прямо ', ' Прямо ')
    .replaceAll(' и ', ' и ')
    .replaceAll(' И ', ' И ')
    .replaceAll(' у ', ' у ')
    .replaceAll(' У ', ' У ')
    .replaceAll(' чем ', ' чем ')
    .replaceAll(' Чем ', ' Чем ')
    .replaceAll(' с ', ' с ')
    .replaceAll(' С ', ' С ')
    .replaceAll(' без ', ' без ')
    .replaceAll(' Без ', ' Без ')
    .replaceAll(' по ', ' по ')
    .replaceAll(' во ', ' во ')
    .replaceAll(' По ', ' По ')
    .replaceAll(' от ', ' от ')
    .replaceAll(' От ', ' От ')
    .replaceAll(' для ', ' для ')
    .replaceAll(' Для ', ' Для ')
    .replaceAll(' в ', ' в ')
    .replaceAll(' В ', ' В ')
    .replaceAll(' о ', ' о ')
    .replaceAll(' О ', ' О ')
    .replaceAll('О ', 'О ')
}
